<template>
    <router-link
        :to="{ name: props.routeItem.route }"
        class="page-link"
        :class="{ 'no-access': !getAccess(props.routeItem.route).hasAccess, expanded: props.expanded }"
        @click="routeClicked"
    >
        <font-awesome-icon
            class="link-icon"
            :aria-label="props.routeItem.name"
            :icon="props.routeItem.icon"
            :title="props.routeItem.name"
        />
        <div v-if="props.expanded" class="text-container">
            <span class="link-text">{{ props.routeItem.name }}</span>
            <span class="link-tags" v-for="(tag, index) in props.routeItem.tags" :key="index">{{ tag }}</span>
        </div>
        <disabled-icon
            v-if="!getAccess(props.routeItem.route).hasAccess"
            :access-required="getAccess(props.routeItem.route).accessRequired"
            class="disabled-icon"
        />
    </router-link>
</template>

<script setup lang="ts">
import { ISidebarRoutesSectionOption } from '@/interfaces/routing/ISidebarRoutes.ts';
import DisabledIcon from '@/components/powerMarkets/common/DisabledIcon.vue';
import { useUIStore } from '@/stores/uiStore.ts';
import { getRouteAccess } from '@/routes/routeUtils.ts';
import { useUserAccessStore } from '@/stores/userAccessStore.ts';

const uiStore = useUIStore();
const userAccessStore = useUserAccessStore();

const props = defineProps<{
    routeItem: ISidebarRoutesSectionOption;
    expanded?: boolean;
}>();

const emit = defineEmits<{ 'close': []}>();

function getAccess (itemRoute: string): {
    hasAccess: boolean;
    accessRequired: string;
} {
    return getRouteAccess(userAccessStore.enactPageAccess, itemRoute);
}

function routeClicked (): void {
    uiStore.updateShowNavSidebar(false);
    emit('close');
}
</script>

<style lang="scss" scoped>
.page-link {
    align-items: center;
    color: var(--primaryFont);
    text-decoration: none;
    cursor: pointer;
    display: grid;
    grid-template-columns: var(--sidebarWidth);
    border-left: 2px solid transparent;
    transition: background-color 0.2s;
    width: 100%;
    height: var(--sidebarRowHeight);

    &:hover {
        background-color: var(--neutral300);
        color: var(--primaryFont);
    }
    &.expanded {
        grid-template-columns: var(--sidebarWidth) 1fr;
    }
    &.no-access {
        grid-template-columns: var(--sidebarWidth) 1fr auto;

        .disabled-icon {
            padding-right: var(--largeSpacing);
        }
    }
    &.router-link-active {
        background-color: var(--neutral300);
        border-left: solid 2px var(--accentColour);
    }

    .text-container {
        display: flex;
        justify-content: space-between;
        padding-right: var(--defaultSpacing);
        .link-text{
            white-space: nowrap;
            font-size: var(--smallFontSize);
        }
        .link-tags {
            padding: calc(var(--smallSpacing) / 2) var(--smallSpacing);
            background-color: var(--neutral400);
            border-radius: var(--borderRadiusOuter);
            font-size: var(--smallFontSize);
        }
    }

    .link-icon {
        justify-self: center;
        font-size: var(--largeFontSize);
    }
}

.sub-item {
    padding-left: var(--defaultSpacing);
    height: var(--sidebarSubRowHeight);

    .link-icon {
        font-size: var(--largeFontSize);
    }
}
</style>
